import { cx } from "class-variance-authority";

export const DetailList = (props: {
  children: React.ReactNode;
  className?: string;
  direction?: "horizontal" | "vertical";
}) => {
  return (
    <dl
      className={cx(
        'items-center" gap-x-4 gap-y-1',
        props.direction === "vertical"
          ? "grid grid-rows-[auto,1fr]"
          : "grid grid-cols-[auto,1fr]",
        props.className,
      )}
    >
      {props.children}
    </dl>
  );
};
